export default __webpack_public_path__ + "static/media/177.ab178ee0.jpg";